import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=03173f06&scoped=true"
import script from "./BaseBanner.vue?vue&type=script&lang=ts"
export * from "./BaseBanner.vue?vue&type=script&lang=ts"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=03173f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03173f06",
  null
  
)

export default component.exports